import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { isRoleGuard } from './guards/is-role.guard';
import { ImportProspectsPage } from './imports/prospects/import-prospects.page';
import { InvoicingPage } from './invoicing/invoicing.page';
import { PartnerLivePage } from './partner/live/live.page';
import { PrivacyPage } from './privacy/privacy.page';
import { UserWeekCalendarPageComponent } from './user-week-calendar/user-week-calendar.page';
import { Roles } from './utility/role';

export const routes: Routes = [
  {
    path: 'clients',
    loadChildren: async () =>
      import('./clients/clients.routing.module'),
  },
  {
    path: 'contractors',
    loadChildren: async () =>
      import('./contractors/contractors-routing.module'),
  },
  {
    path: 'feedback',
    loadChildren: async () =>
      import('./feedback/feedback-page-routing.module'),
  },
  {
    path: 'info',
    loadChildren: async () =>
      import('./info/info-routing.module'),
  },
  {
    path: 'privacy',
    component: PrivacyPage,
  },
  {
    path: 'kanban-dashboard',
    loadChildren: async () =>
      import('./kanban/dashboard/kanban-dashboard-routing.module'),
  },
  {
    path: 'home',
    loadChildren: async () =>
      import('./home/home-routing.module'),
  },
  {
    path: 'import/prospects',
    component: ImportProspectsPage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'instructions',
    loadChildren: async () =>
      import('./instructions/instructions.routing.module'),
  },
  {
    path: 'invoicing',
    component: InvoicingPage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'lastplanner',
    loadChildren: async () =>
      import('./lastplanner/lastplanner-routing.module'),
  },
  {
    path: 'login',
    loadChildren: async () =>
      import('./login/login-routing.module'),
  },
  {
    path: 'logs',
    loadChildren: async () =>
      import('./logs/logs-page-routing.module'),
  },
  {
    path: 'merge-users',
    loadChildren: async () =>
      import('./merge-users/merge-users-routing.module'),
  },
  {
    path: 'options',
    loadChildren: async () =>
      import('./options/options-routing.module'),
  },
  {
    path: 'partner/live',
    component: PartnerLivePage,
    canActivate: [isRoleGuard([Roles.superAdmin, Roles.partner])],
  },
  {
    path: 'profile',
    loadChildren: async () =>
      import('./profile/profile-routing.module'),
  },
  {
    path: 'register',
    loadChildren: async () =>
      import('./register/register-routing.module'),
  },
  {
    path: 'report/locations',
    loadChildren: async () =>
      import('./report/locations/locations-routing.module'),
  },
  {
    path: 'schedule',
    loadChildren: async () =>
      import('./schedule/schedule-routing.module'),
  },
  {
    path: 'sign-up',
    loadChildren: async () =>
      import('./on-boarding/on-boarding.routing.module'),
  },
  {
    path: 'sites',
    loadChildren: async () =>
      import('./sites/sites.routing.module'),
  },
  {
    path: 'templates',
    loadChildren: async () =>
      import('./templates/templates-routing.module'),
  },
  {
    path: 'users',
    loadChildren: async () =>
      import('./users/users-routing.module'),
  },
  {
    path: 'user-week-calendar',
    component: UserWeekCalendarPageComponent,
  },
  {
    path: 'week-user',
    loadChildren: async () => import('./kanban/user-week-view/user-week-view-routing-module'),
  },
  {
    path: 'waiting',
    loadChildren: async () =>
      import('./waiting/waiting-routing.module'),
  },
  {
    path: 'worker',
    loadChildren: async () =>
      import('./worker/worker-routing.module'),
  },
  {
    path: '',
    redirectTo: environment.home,
    pathMatch: 'full',
  },
];
